const STORAGE_KEYS = {
    COZE_ACCESS_TOKEN: 'coze_access_token',
    COZE_BOT_ID: 'coze_bot_id',
    AIRPLANE_TOKEN: 'nixiaofengAirplane_token'
};

const COOKIE_KEYS = {
    TOKEN: 'nixiaofengAirplane_token'
};

const API_DOMAIN = {
    COZE: 'https://api.coze.cn'
};

const COZE_CONFIG = {
    MAX_RETRY: 3,
    SDK_URL: 'https://lf-cdn.coze.cn/obj/unpkg/flow-platform/chat-app-sdk/1.2.0-beta.20/libs/cn/index.js',
    CONFIG_URL: '/coze-config.js'
};

export {
    STORAGE_KEYS,
    COOKIE_KEYS,
    API_DOMAIN,
    COZE_CONFIG
};
